import React from "react";

/**
 * Reusable AI Analyzer button for chart headers.
 */
const AIAnalyzerButton = ({ onClick, label = "AI Analyzer", size = "normal" }) => {
  const isSmall = size === "small";

  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: isSmall ? "4px 10px" : "6px 14px",
        borderRadius: "20px",
        border: "1px solid #bfdbfe",
        background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
        color: "#1d4ed8",
        fontSize: isSmall ? "11px" : "12px",
        fontWeight: 700,
        cursor: "pointer",
        transition: "all 0.2s ease",
        boxShadow: "0 1px 3px rgba(37, 99, 235, 0.12)",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)";
        e.currentTarget.style.transform = "translateY(-1px)";
        e.currentTarget.style.boxShadow = "0 3px 8px rgba(37, 99, 235, 0.2)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)";
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 1px 3px rgba(37, 99, 235, 0.12)";
      }}
      aria-label="Analyze graph with AI"
      title="Generate AI natural language insights for this chart"
    >
      <span style={{ fontSize: isSmall ? "12px" : "14px" }}>✨</span>
      <span>{label}</span>
    </button>
  );
};

export default AIAnalyzerButton;
